export enum DeepResearchStage {
  START = 'start',
  CLARIFICATION = 'clarification',
  PLANNING = 'planning',
  EXECUTION = 'execution',
  GENERATION = 'generation',
  END = 'end',
}

export enum DeepResearchExecutionStep {
  BEGIN = 'begin',
  APPEND = 'append',
  END = 'end',
}

export enum DeepResearchTasksStatus {
  PENDING = 'pending',
  BEGIN = 'begin',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  FAILED = 'failed',
}

export interface ResearchPlanTask {
  id: string;
  content: string;
  subTasks?: ResearchPlanTask[];
  toolCalls?: {
    toolName: string;
    capability: string;
    toolCallId: string;
    argsJson: string;
  }[];
}

export interface DeepResearchResponse {
  clarification?: string;
  researchId: string;
  stage: DeepResearchStage;
  researchPlan?: { message?: string; tasks: ResearchPlanTask[] };
  executedPlan?: {
    step: DeepResearchExecutionStep;
    tasks: (ResearchPlanTask & { status?: DeepResearchTasksStatus })[];
  };
  title: string; // this will hold a default value in case nothing returned from the server
  planUpdateCount?: number;
  userPrompts?: { timestamp: string; prompt: string }[];
  content?: string;
}
